import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { navigate } from '@gatsbyjs/reach-router';
import { SearchButton } from '../buttons/styles';
import { SEARCH_PATH } from '../../search/constants';
import { buildSearchQuery } from '../../search/helpers';
import { sendEvent } from '../../../utils/analytics';
import { SearchForm, InputWrapper } from './styles';
import SearchInput from '../../search-box/search-input';
import { country } from '../../../utils/current-site';

/**
 * Shared top search bar, appears on desktop, mobile expanded, and
 * in the side-drawer.
 */
const SearchBar = ({ placement = '', searchFocus = false }) => {
  const placeholder = 'Search';
  const labelText = `Search Shelter ${country} site`;

  return (
    <Formik
      initialValues={{ query: '' }}
      onSubmit={(values) => {
        navigate(buildSearchQuery(values));
        sendEvent({
          event: 'formSubmitted',
          formName: 'site-search-header',
          query: values.query,
        });
      }}
    >
      {() => (
        <SearchForm
          as={Form}
          action={SEARCH_PATH}
          method="GET"
          role="search"
          aria-label="Sitewide"
        >
          <InputWrapper $placement={placement}>
            <SearchInput
              name="query"
              id="search"
              placeholder={placeholder}
              labelText={labelText}
              ref={(input) => input && searchFocus && input.focus()}
              suggestionHeading="Suggestions"
              suggestionPrefixIcon="search"
              inHeader={
                placement === 'mobileHeader' || placement === 'desktopHeader'
              }
            />

            <SearchButton
              type="submit"
              bg="secondary-standard"
              icon="search"
              iconPlacement="center"
              aria-label="Submit Search"
              size={placement === 'mobileHeader' ? 'small' : 'regular'}
              data={{ headernav: 'search', headerbutton: 'searchSubmit' }}
            />
          </InputWrapper>
        </SearchForm>
      )}
    </Formik>
  );
};

SearchBar.propTypes = {
  placement: PropTypes.oneOf(['mobileHeader', 'mobileDrawer', 'desktopHeader']),
  searchFocus: PropTypes.bool,
};

export default SearchBar;
